import {
  ChartBar33Icon,
  ExchangeIcon,
  MetricsIcon,
  RunningShoeIcon,
  YogaIcon,
} from 'fitify-ui/src/Icon/fill'
import type { DataTypes } from 'fitify-ui-landing/src/@types'

export const workStatisticsData: DataTypes.WorkStatisticItem[] = [
  {
    icon: <ExchangeIcon />,
    iconColor: 'Blue400',
    percent: '80%',
    content: 'landing_work_statistics_1_body',
  },
  {
    icon: <ChartBar33Icon />,
    iconColor: 'Blue400',
    percent: '41%',
    content: 'landing_work_statistics_2_body',
  },
  {
    icon: <MetricsIcon />,
    iconColor: 'Blue400',
    percent: '27%',
    content: 'landing_work_statistics_3_body',
  },
  {
    icon: <YogaIcon />,
    iconColor: 'Blue400',
    percent: '21%',
    content: 'landing_work_statistics_4_body',
  },
  {
    icon: <RunningShoeIcon />,
    iconColor: 'Blue400',
    percent: '15%',
    content: 'landing_work_statistics_5_body',
  },
]
